import React from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { withFormik } from "formik"
import { Formik, Form, Field, FieldArray, getIn } from "formik"
import { create, show, list, update, destroy } from "./actions"
import {
  mapOptionLabels,
  getAllowedFields,
  getRemainingDays,
  isAmountRangeValid,
  amountToExpenseOrRevenue,
  accountsFromInstitutionUsers,
  getCombinedPurpose,
  setPurposeAndIncomeSource,
  revenueOrExpenseToAmount,
  validateForm
} from "./"
import Rule from "./Rule"

const mapDispatchToProps = (
  dispatch,
  {
    match: {
      params: { tokenId }
    }
  }
) => {
  return { actions: bindActionCreators({ create }, dispatch) }
}

const mapStateToProps = ({
  account: { faveTxns },
  models: {
    user: { favorite_transactions, institution_users }
  }
}) => {
  return {
    buttonTitle: "Save",
    title: "New Rule",
    data: []
  }
}

// Wrap our form with the using withFormik HoC
const RulesWithFormik = withFormik({
  // Transform outer props into form values
  mapPropsToValues: ({ data }) => {
    return {
      ...data,
      rules: [
        {
          type: "EqualityRule",
          observed_field: "merchant",
          comparison_operator: "=~",
          enforced_value: null
        }
      ],

      rule_actions: [
        {
          enforced_field: "purpose",
          enforced_value: null
        },
        {
          enforced_field: "notes",
          enforced_value: null
        }
      ]
      // rules
    }
  },

  validate: (values, props) => validateForm(values, props),
  // Submission handler

  enableReinitialize: true,
  handleSubmit: (
    values,
    {
      props,
      setSubmitting,
      setErrors /* setValues, setStatus, and other goodies */
    }
  ) => {
    // LoginToMyApp(values).then(
    props.actions
      .create(
        values.rules.map(r => revenueOrExpenseToAmount(r)),
        values.rule_actions
          .filter(ra => ra.enforced_value !== null) //remove either with empty enforced_value
          .filter(ra => ra.enforced_value.trim() != "")
      )
      .then(
        response => {
          setSubmitting(false)
          //     // do whatevs...
          //     // props.updateUser(user)
        },
        errors => {
          setSubmitting(false)
          //     // Maybe even transform your API's errors into the same shape as Formik's!
          //     setErrors(transformMyApiErrors(errors))
        }
      )
  }
})(Rule)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RulesWithFormik)



// WEBPACK FOOTER //
// ./src/account/favorite-transactions/New.js